import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Col, Row, Tabs } from 'antd'
import LoyaltyOverview from './LoyaltyOverview'
import LoyaltyCards from './LoyaltyCards'
import LoyaltyBonusContainer from './LoyaltyBonusContainer'

const { TabPane } = Tabs

const Loyalty = () => {
  const history = useHistory()
  const location = useLocation()

  const getActiveKey = () => {
    if (location.pathname === '/loyalty') return 'overview'
    if (location.pathname.includes('/loyalty/cards')) return 'cards'
    if (location.pathname.includes('/loyalty/bonuses')) return 'bonuses'
    return 'overview'
  }

  const handleTabChange = (key: string) => {
    history.push(`/loyalty/${key}`)
  }

  useEffect(() => {
    if (location.pathname === '/loyalty') {
      history.replace('/loyalty/overview')
    }
  }, [location.pathname, history])

  return (
    <>
      <Row>
        <Col span={24}>
          <Tabs
            type='card'
            activeKey={getActiveKey()}
            onChange={handleTabChange}
            data-testid='loyaltyIndex'
            destroyInactiveTabPane
          >
            <TabPane
              tab={<a data-testid='loyalty-overview-tab-pane'>OVERVIEW</a>}
              key='overview'
            >
              <LoyaltyOverview />
            </TabPane>
            <TabPane
              tab={<a data-testid='loyalty-cards-tab-pane'>YOUR CARDS</a>}
              key='cards'
            >
              <LoyaltyCards />
            </TabPane>
            <TabPane
              tab={
                <a data-testid='loyalty-bonuses-tab-pane'>LOYALTY BONUSES</a>
              }
              key='bonuses'
            >
              <LoyaltyBonusContainer />
            </TabPane>
          </Tabs>
        </Col>
      </Row>
    </>
  )
}

export default Loyalty
